import apiClient from "../api/apiClient"
import { Booker, PaginatedResponse, ResetUserPasswordPayload } from "../../types"

export interface CreateUserPayload {
  name: string
  email: string
  password: string
}

export interface UpdateUserPayload {
  name: string
}

export const userService = {
  async getUsers(params?: {
    page?: number
    limit?: number
    search?: string
    type?: string
  }): Promise<PaginatedResponse<Booker>> {
    const response = await apiClient.get<{
      info: {
        page: number
        limit: number
        total: number
        totalPages: number
        hasNextPage: boolean
      }
      results: Booker[]
    }>("/admin/users/get-all", { params: { ...params, type: 'booker' } })
    
    return {
      data: response.data.results,
      total: response.data.info.total,
      page: response.data.info.page,
      limit: response.data.info.limit,
      totalPages: response.data.info.totalPages,
    }
  },

  async createUser(payload: CreateUserPayload): Promise<{ message: string; booker: Booker }> {
    const response = await apiClient.post<{ message: string; booker: Booker }>(
      "/admin/users/create-booker",
      payload
    )
    return response.data
  },

  async updateUser(id: string, payload: UpdateUserPayload): Promise<{ message: string; booker: Booker }> {
    const response = await apiClient.put<{ message: string; booker: Booker }>(
      `/admin/users/update-booker/${id}`,
      payload
    )
    return response.data
  },

  async resetUserPassword(id: string, payload: ResetUserPasswordPayload): Promise<{ message: string }> {
    const response = await apiClient.put<{ message: string }>(
      `/admin/users/reset-password/${id}`,
      payload
    )
    return response.data
  },
}

